var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 10.834C10.6669 10.834 11.3028 10.5706 11.7717 10.1018C12.2405 9.63291 12.5039 8.99703 12.5039 8.33398C12.5039 7.67094 12.2405 7.03506 11.7717 6.56622C11.3028 6.09738 10.6669 5.83398 10.0039 5.83398C9.34086 5.83398 8.70498 6.09738 8.23614 6.56622C7.7673 7.03506 7.50391 7.67094 7.50391 8.33398C7.50391 8.99703 7.7673 9.63291 8.23614 10.1018C8.70498 10.5706 9.34086 10.834 10.0039 10.834Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 18.3337C13.3359 15.0003 16.6693 12.0153 16.6693 8.33366C16.6693 6.56555 15.9669 4.86986 14.7166 3.61961C13.4664 2.36937 11.7707 1.66699 10.0026 1.66699C8.23449 1.66699 6.5388 2.36937 5.28856 3.61961C4.03832 4.86986 3.33594 6.56555 3.33594 8.33366C3.33594 12.0153 6.66927 15.0003 10.0026 18.3337Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.c2e56b6c009dcca782bd7dec88551668.svg";
export { ForwardRef as ReactComponent };